import { ResHandle, formatCST } from '@/utils/utils'
const state = {
  page: 1,
  total: 0,
  limit: 100,
  class_id: '',
  phone: '',
  unit_name: '',
  username: '',
  real_name: '',
  is_activated: '',
  activateDate: [],
  createDate: [],
  activated_at_from: null,
  activated_at_to: null,
  created_at_from: null,
  created_at_to: null,
  showModal: false
}

const actions = {
  // 处理学生列表搜索条件
  handleStudentManageParams({ state }) {
    const data = {
      activated_at_from:
        state.activated_at_from && formatCST(state.activated_at_from),
      activated_at_to:
        state.activated_at_to && formatCST(state.activated_at_to),
      created_at_from:
        state.created_at_from && formatCST(state.created_at_from),
      created_at_to: state.created_at_to && formatCST(state.created_at_to),
      unit_type_id: state.unit_type_id,
      phone: state.phone,
      username: state.username,
      class_id: state.class_id,
      real_name: state.real_name,
      is_activated: state.is_activated
    }
    Object.keys(data).forEach(key => {
      if (!data[key] && key !== 'is_activated') {
        delete data[key]
      }
    })
    if (data['is_activated'] === 2 || data['is_activated'] === '') {
      delete data['is_activated']
    }
    return data
  },
  // student get data
  async studentManageGetData({ commit, state, rootState }, playload) {
    const unit_id = rootState.user.role_id
    const { page, limit } = state
    if (unit_id === 40001) {
      const data = {
        class_id: state.class_id,
        created_at_from:
          state.created_at_from && formatCST(state.created_at_from),
        created_at_to: state.created_at_to && formatCST(state.created_at_to),
        is_activated: state.is_activated,
        name: state.real_name,
        unit_name: state.unit_name,
        activated_at_from:
          state.activated_at_from && formatCST(state.activated_at_from),
        activated_at_to:
          state.activated_at_to && formatCST(state.activated_at_to)
        // unit_type_id: state.unit_type_id,
      }
      Object.keys(data).forEach(key => {
        if (!data[key] && key !== 'is_activated') {
          delete data[key]
        }
      })
      if (data['is_activated'] === 2 || data['is_activated'] === '') {
        delete data['is_activated']
      }
      const res = await API.get(
        `/edu/zone/channel/agent/students?page=${page}`,
        data
      )
      if (res.status < 400) {
        commit('setState', {
          module: 'studentManage',
          key: 'total',
          value: res.data.total
        })
      }
      return res
    } else {
      const data = {
        activated_at_from:
          state.activated_at_from && formatCST(state.activated_at_from),
        activated_at_to:
          state.activated_at_to && formatCST(state.activated_at_to),
        created_at_from:
          state.created_at_from && formatCST(state.created_at_from),
        created_at_to: state.created_at_to && formatCST(state.created_at_to),
        unit_type_id: state.unit_type_id,
        phone: state.phone,
        username: state.username,
        class_id: state.class_id,
        real_name: state.real_name,
        is_activated: state.is_activated,
        invalid: 1 // m12w1新增班级参数 0：无班级 1：有班级
      }
      Object.keys(data).forEach(key => {
        if (!data[key] && key !== 'is_activated') {
          delete data[key]
        }
      })
      if (data['is_activated'] === 2 || data['is_activated'] === '') {
        delete data['is_activated']
      }
      const res = await API.post(`/edu/zone/students?page=${page}&limit=${limit}`, data)
      if (res.status < 400) {
        commit('setState', {
          module: 'studentManage',
          key: 'total',
          value: res.data.total
        })
      }
      return res
    }
  },
  // student edit name
  async studentManageEditName({ commit }, playload) {
    const res = await API.patch(`/edu/zone/students/${playload.id}`, {
      real_name: playload.real_name
    })
    return ResHandle(res)
  },
  // edit score
  async studentManageEditScore({ commit }, playload) {
    const res = await API.put(`/edu/zone/students/${playload.id}/score`, {
      score: playload.score
    })
    return ResHandle(res)
  },
  // 导出学生列表
  async studentManageExcel({ commit, state }) {
    const data = {
      activated_at_from:
        state.activated_at_from && formatCST(state.activated_at_from),
      activated_at_to:
        state.activated_at_to &&
        formatCST(moment(state.activated_at_to).add(24, 'h')),
      created_at_from:
        state.created_at_from && formatCST(state.created_at_from),
      created_at_to:
        state.created_at_to &&
        formatCST(moment(state.created_at_to).add(24, 'h')),
      unit_type_id: state.unit_type_id,
      phone: state.phone,
      username: state.username,
      class_id: state.class_id,
      real_name: state.real_name,
      is_activated: state.is_activated,
      invalid: 1 // m12w1新增班级参数 0：无班级 1：有班级
    }
    Object.keys(data).forEach(key => {
      if (!data[key] && key !== 'is_activated') {
        delete data[key]
      }
    })
    if (data['is_activated'] === 2 || data['is_activated'] === '') {
      delete data['is_activated']
    }
    const res = await API.get('/edu/zone/students/excel', data, {
      responseType: 'arraybuffer'
    })
    return res
  },
  // 重置密码
  async restStudentPwd({ commit }, id) {
    const res = await API.patch(`/edu/zone/students/${id}/password`)
    return res
  },
  // 批量重置密码
  async batchResetStudentPwd({ commit }, student_id) {
    const res = await API.patch('/edu/zone/students/password', { student_id }, {
      responseType: 'arraybuffer'
    })
    return res
  },
  // 删除学生
  async deleteStudent ({ commit }, id) {
    const res = await API.post(`/edu/zone/student/remove/${id}`)
    return res
  }
}

const mutations = {
  studentManageInit(state) {
    state.class_id = ''
    state.phone = ''
    state.username = ''
    state.real_name = ''
    state.is_activated = ''
    state.unit_name = ''
    state.activated_at_from = null
    state.activated_at_to = null
    state.created_at_from = null
    state.created_at_to = null
    state.page = 1
    state.limit = 100
  }
}

export default {
  state,
  actions,
  mutations
}
